import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";
import React from "react";

function AddCargoSkeleton() {
	return (
        <Box>
            <Grid container rowSpacing={3.6} columnSpacing={2}>
				<Grid
                    size={{
                        lg: 7
                    }}>
					<Skeleton variant="rectangular" height={138} />
				</Grid>
				<Grid
                    size={{
                        lg: 5
                    }}>
					<Skeleton variant="rectangular" height={138} />
				</Grid>
				<Grid
                    size={{
                        lg: 6
                    }}>
					<Skeleton variant="rectangular" height={224} />
				</Grid>
				<Grid
                    size={{
                        lg: 6
                    }}>
					<Skeleton variant="rectangular" height={224} />
				</Grid>
				<Grid
                    size={{
                        lg: 6
                    }}>
					<Box sx={{ display: "flex", justifyContent: "end" }}>
						<Skeleton variant="rectangular" width={124.217} height={35.8} />
					</Box>
				</Grid>
				<Grid
                    size={{
                        lg: 6
                    }}>
					<Box sx={{ display: "flex", justifyContent: "start" }}>
						<Skeleton variant="rectangular" width={68.45} height={35.8} />
					</Box>
				</Grid>
			</Grid>
        </Box>
    );
}

export default AddCargoSkeleton;
